module.exports = __webpack_public_path__ + "static/media/ac.ba734b1b.jpg";